module.exports = __webpack_public_path__ + "img/cabbage - aquarelle.32cb7c79.png";